module.exports = __webpack_public_path__ + "logo_white.png?15283e08a2a834de572d1a9533acd904";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_white.png
// module id = 6
// module chunks = 0